<template>
  <v-toolbar>
      <v-tabs align-with-title>
        <v-tabs-slider color="blue"></v-tabs-slider>
        <v-tab
          v-for="(tab, i) in tabs"
          :key="`tab-${i}`"
          @click="$router.push({ name: tab.link })"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    <v-spacer />
    <cvc-actions v-if="includeBrandSelect" />
  </v-toolbar>
</template>

<script>
import CvcActions from "@/components/CvcActions";
export default {
  components: { CvcActions },
  data() {
    return {
      cvcIcon: require("../assets/Covatic.png"),
      selectedTab: null,
      tabs: [
        { title: "Builder", link: "NotificationsBuilder" },
        { title: "Reporting", link: "NotificationsReporting" },
        { title: "Segments", link: "NotificationsSegments" },
      ],
    };
  },
  computed: {
    includeBrandSelect() {
      return this.$route.meta?.includeBrandSelect;
    },
  },
  mounted() {
    this.selectedTab = this.$route.name;
  },
};
</script>
